/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "multipass": {
        "nested": {
          "service": {
            "nested": {
              "Error": {
                "values": {
                  "NO_ERROR": 0,
                  "TEMPORARY_LOCKOUT": 1000,
                  "EMAIL_INVALID": 1001,
                  "USER_TOKEN_INVALID": 1002,
                  "NEW_EMAIL_INVALID": 1003,
                  "NEW_EMAIL_TAKEN": 1004,
                  "PHONE_INVALID": 1005,
                  "CAPTCHA_REQUIRED": 1006,
                  "CAPTCHA_RESPONSE_INVALID": 1007,
                  "FORWARD_TO_MASTER": 1008,
                  "VERIFICATION_REQUIRED": 1009,
                  "VERIFICATION_METHOD_INVALID": 1010,
                  "VERIFICATION_CODE_NOT_SENT": 1011,
                  "ACCOUNT_LOCKED": 1012,
                  "ALIAS_IN_USE": 1013,
                  "ALIAS_INVALID": 1014,
                  "ACCOUNT_ALREADY_CLAIMED": 1015,
                  "PROOF_OF_WORK_MISSING": 1016,
                  "PROOF_OF_WORK_INVALID": 1017,
                  "PROOF_OF_WORK_EXPIRED": 1018,
                  "PROOF_OF_WORK_INCORRECT": 1019,
                  "GENERATE_OTP_FAILED": 1020,
                  "NEW_PHONE_INVALID": 1021,
                  "NEW_PHONE_TAKEN": 1022,
                  "PASSWORD_INVALID": 2000,
                  "VERIFICATION_CODE_INVALID": 2001,
                  "PASSWORD_REUSE": 2002,
                  "PASSWORD_COMMON": 2003,
                  "PASSWORD_COMPROMISED": 2004,
                  "PASSWORD_FAILS_REQUIREMENTS": 2005,
                  "PASSWORD_TOO_SHORT": 2006,
                  "PASSWORD_TOO_LONG": 2007,
                  "PASSWORD_SIMILAR_TO_EMAIL": 2008,
                  "DORMANT_ACCOUNT": 2009,
                  "SECURE_CONTACT_CONFLICT": 2010,
                  "SECURE_CONTACT_VERIFICATION_REQUIRED": 2011,
                  "SECURE_CONTACT_NOT_FOUND": 2012,
                  "SECURE_CONTACT_ALIAS_CONFLICT": 2013,
                  "RECOVERY_ATTEMPTS_EXCEEDED": 2014,
                  "RECOVERY_DECISION_DECLINED": 2015,
                  "RECOVERY_VERIFICATION_REQUIRED": 2016,
                  "BLOCKED_SMS_NUMBER": 2017,
                  "MANDATORY_2FA": 2018,
                  "REGISTERED_PASSKEYS_LIMIT": 2019,
                  "PASSKEY_REGISTRATION_FAILED": 2020,
                  "PASSKEY_DEREGISTRATION_FAILED": 2021,
                  "PASSKEY_AUTHENTICATION_FAILED": 2022,
                  "PASSKEY_AUTHENTICATION_INVALID": 2023,
                  "SESSION_ID_INVALID": 3000,
                  "SESSION_ID_EXPIRED": 3001,
                  "SESSION_ID_TERMINATED": 3002,
                  "SESSION_ID_IDLE": 3003,
                  "SESSION_ID_INVALID_SELECTION": 3004,
                  "SESSION_ID_ASSUMED_INVALID": 3005,
                  "SESSION_SECONDARY_TOKEN_INVALID": 3006,
                  "SESSION_COOKIE_INVALID": 3007,
                  "ACCESS_TOKEN_INVALID": 3008,
                  "OAUTH_SESSION_DISABLED": 3009,
                  "TOKEN_INVALID": 3010,
                  "IP_ADDRESS_INVALID": 3011,
                  "ACCESS_TOKEN_EXPIRED": 3012,
                  "ACCESS_TOKEN_REVOKED": 3013,
                  "SESSION_ID_MISSING": 3014,
                  "ACCESS_TOKEN_MISSING": 3015,
                  "SESSION_ID_MULTIPLE": 3016,
                  "ACCESS_TOKEN_MULTIPLE": 3017,
                  "ACCESS_TOKEN_LEGACY_SANDBOX": 3018,
                  "REFRESH_TOKEN_INVALID": 3019,
                  "TWO_FACTOR_REQUIRED": 3020,
                  "TARGET_TOKEN_MISSING": 3021,
                  "TARGET_TOKEN_MULTIPLE": 3022,
                  "ACTOR_ID_INVALID": 3023,
                  "CALLER_CLIENT_OU_INVALID": 3024,
                  "END_USER_CREDENTIAL_INVALID": 3025,
                  "END_USER_CREDENTIAL_MULTIPLE": 3026,
                  "END_USER_CREDENTIAL_EMPTY": 3027,
                  "DEVICE_DETAILS_INVALID": 4000,
                  "DEVICE_CREDENTIAL_TOKEN_INVALID": 4001,
                  "DEVICE_CREDENTIAL_LIMIT_EXCEEDED": 4002,
                  "DEVICE_CREDENTIAL_EXPECTED_REGISTER_PRODUCT": 4003,
                  "DEVICE_CREDENTIAL_EXPECTED_RETAIL_PRODUCT": 4004,
                  "DEVICE_CREDENTIAL_EXPECTED_RESTAURANT_PRODUCT": 4005,
                  "DEVICE_CREDENTIAL_ALREADY_PAIRED": 4006,
                  "DEVICE_CREDENTIAL_EXPECTED_KDS_PRODUCT": 4007,
                  "DEVICE_CREDENTIAL_EXPECTED_RESTAURANT_MOBILE_PRODUCT": 4008,
                  "DEVICE_CREDENTIAL_SOFTWARE_UPDATE_REQUIRED": 4009,
                  "DEVICE_CREDENTIAL_UNPAIRED_LIMIT_EXCEEDED": 4010,
                  "DEVICE_CREDENTIAL_EXPECTED_TERMINAL_API_PRODUCT": 4011,
                  "DEVICE_CREDENTIAL_EXPECTED_FNB_KIOSK_PRODUCT": 4012,
                  "DEVICE_CREDENTIAL_EXPECTED_INVOICES_PRODUCT": 4013,
                  "OTK_INVALID": 5000,
                  "REPLICATION_LAG": 6000,
                  "RATE_LIMITED": 6001,
                  "RETRIED_AFTER_SUCCESS": 6002,
                  "MERCHANT_INVALID": 7000,
                  "UNIT_INVALID": 7001,
                  "APPLICATION_NOT_ALLOWED": 7002,
                  "REDIRECT_URL_INVALID": 7003,
                  "PERSON_TOKEN_INVALID": 7004,
                  "EMPLOYMENTS_INVALID": 7005,
                  "CREDENTIAL_TOKEN_INVALID": 8000,
                  "PERSON_TOKEN_INVALID_CASH_USER": 8001,
                  "CASH_APP_MERCHANT_NO_LOGIN": 8002,
                  "NOT_FOUND": 9000
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.multipass?.nested?.service?.nested?.Error) {
  $root.addJSON(jsonData);
}

/**
 * Application-level errors are returned for expected failure cases, which depend on input
 * from a user (which might be bad).  Programming bugs in client code (e.g. negative duration)
 * will throw RpcException(INVALID_REQUEST).
 *
 * SOURCE Error @ squareup/multipass/service/error.proto at 16:1
 */
export const Error = $root.lookupEnum('squareup.multipass.service.Error').values;